'use es6';

import Raven from 'Raven';
var ENDPOINT_EXPOSURE_BULK_LOG = "treatments/v2/exposure/log-bulk";
var ENDPOINT_TREATMENTS_BULK_GET = "treatments/v2/bulk-get";
var SENTRY_EXTRA_OPTS = {
  fingerprint: ['laboratory-lib', 'network']
};

function ensureFn(fn) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  if (typeof fn !== 'function') {
    return fallback;
  }

  return fn;
}

function logError(err) {
  if (typeof err === 'string') {
    ensureFn(console.log)(err);
  } else {
    ensureFn(console.error)(err);
  }
}

export function reportError(err) {
  try {
    if (typeof err === 'string') {
      Raven.captureMessage(err, SENTRY_EXTRA_OPTS);
    } else {
      Raven.captureException(err, SENTRY_EXTRA_OPTS);
    }

    logError(err);
  } catch (err2) {
    logError(err2);
  }
}
export function logExposures() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$apiDomain = _ref.apiDomain,
      apiDomain = _ref$apiDomain === void 0 ? '' : _ref$apiDomain,
      exposures = _ref.exposures,
      http = _ref.http,
      onError = _ref.onError;

  return http.post(apiDomain + "/" + ENDPOINT_EXPOSURE_BULK_LOG, {
    data: exposures
  }).catch(ensureFn(onError));
}
export function getTreatmentsFromHttp() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$apiDomain = _ref2.apiDomain,
      apiDomain = _ref2$apiDomain === void 0 ? '' : _ref2$apiDomain,
      ceid = _ref2.ceid,
      data = _ref2.data,
      http = _ref2.http,
      onComplete = _ref2.onComplete,
      onError = _ref2.onError,
      timeout = _ref2.timeout;

  if (timeout === 0) {
    ensureFn(onError)(new Error('laboratory-lib - hub-http timeout'));
  } else {
    var query = {};

    if (ceid) {
      query.ceid = ceid;
    }

    http.post(apiDomain + "/" + ENDPOINT_TREATMENTS_BULK_GET, {
      timeout: timeout,
      data: data,
      query: query
    }).then(onComplete).catch(ensureFn(onError));
  }
}
export function getTreatmentsFromQuickFetch(_ref3) {
  var onComplete = _ref3.onComplete,
      onError = _ref3.onError,
      quickFetch = _ref3.quickFetch,
      quickFetchLabel = _ref3.quickFetchLabel,
      timeout = _ref3.timeout;
  var requestState = quickFetch.getRequestStateByName(quickFetchLabel);

  if (!requestState) {
    ensureFn(onError)(new Error("laboratory-lib expected window.quickFetch.getRequestStateByName(\"" + quickFetchLabel + "\") to return request state."));
  } else if (timeout === 0) {
    ensureFn(onError)(new Error('laboratory-lib - quick-fetch timeout'));
  } else {
    var timeoutInterval = setInterval(function () {
      ensureFn(onError)(new Error('laboratory-lib - quick-fetch timeout'));
      clearInterval(timeoutInterval);
    }, timeout);
    requestState.whenFinished(function (treatments) {
      onComplete(treatments);
      clearInterval(timeoutInterval);
    });
    requestState.onError(function (xhr, err) {
      ensureFn(onError)(err);
      clearInterval(timeoutInterval);
    });
  }
}